import Box from '@mui/material/Box';
import CircularProgress from '@mui/material/CircularProgress';

export function AuthLoadingFallback() {
  return (
    <Box
      sx={{
        minHeight: '100dvh',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        bgcolor: 'background.default',
      }}
    >
      <CircularProgress color="primary" />
    </Box>
  );
}
